/**
 * @generated SignedSource<<68ede829ccd8475ef7718dac6a1a3df6>>
 * @relayHash 39d6a72d5b5b54c388e853287b5b83d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceTeamAdminControlsMode = "ALL_TEAMS" | "MEMBER_MANAGED_TEAMS" | "NO_TEAMS" | "VERIFIED_TEAMS" | "%future added value";
export type useConfluenceSiteTeamConfigurationsQuery$variables = Record<PropertyKey, never>;
export type useConfluenceSiteTeamConfigurationsQuery$data = {
  readonly confluence: {
    readonly siteConfiguration: {
      readonly teamAdminControlsSettings: {
        readonly teamAdminControlsMode: ConfluenceTeamAdminControlsMode | null;
      } | null;
    } | null;
  } | null;
};
export type useConfluenceSiteTeamConfigurationsQuery = {
  response: useConfluenceSiteTeamConfigurationsQuery$data;
  variables: useConfluenceSiteTeamConfigurationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceQueryApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSiteConfiguration",
        "kind": "LinkedField",
        "name": "siteConfiguration",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceTeamAdminControlsSettings",
            "kind": "LinkedField",
            "name": "teamAdminControlsSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "teamAdminControlsMode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useConfluenceSiteTeamConfigurationsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useConfluenceSiteTeamConfigurationsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "39d6a72d5b5b54c388e853287b5b83d9",
    "id": "bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4",
    "metadata": {},
    "name": "useConfluenceSiteTeamConfigurationsQuery",
    "operationKind": "query",
    "text": "query useConfluenceSiteTeamConfigurationsQuery{confluence{siteConfiguration{teamAdminControlsSettings{teamAdminControlsMode}}}}"
  }
};
})();

(node as any).hash = "dc96564c26929e9d164a8c5239b5e482";

export default node;
